import { render, staticRenderFns } from "./EvolucionAcumuladoTab.vue?vue&type=template&id=6c1c8b23&"
import script from "./EvolucionAcumuladoTab.vue?vue&type=script&lang=js&"
export * from "./EvolucionAcumuladoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports